import React, { useEffect, useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import Navbar from '../../frontend/abstact/Navbar';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useLocation } from 'react-router-dom';
const theme = createTheme();
const BankPaymentVerification = () => {
    const history = useHistory();
    const location = useLocation();
    const URL = window.location.href;
    const bankVerifiction = document.URL.split("/").slice(-1)[0];
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [addBank, setAddBank] = useState({
        // particent_id: `${participantSingleData.id || ""}`,
        particent_bank: "",
        particent_ref_no: "",

    });
    const [participantData, setParticipantData] = useState({});
    React.useEffect(() => {
        axios.get(`api/workshop-bank-verifiction/${bankVerifiction}`).then(res => {

            if (res.status === 200) {
                const FieldList = res.data.updateparticipantForm;
                setParticipantData(FieldList)

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })

    }, []);

    const [bankReceipt, setBankReceipt] = useState("");

   


    const eventid = localStorage.getItem('eventid')
    const bankDetailSubmit = (e) => {
        e.preventDefault();
        const bankVerifictions = "bankVerifictions";
        const participant_id = participantData.id;
        const participantId = participantData.id;
        const event_id = participantData.event_id;
        const data = {

            // particent_id: `${participantSingleData.id || ""}`,
            event_id,
            particent_bank: addBank.particent_bank,
            particent_ref_no: addBank.particent_ref_no,
            bankVerifictions,
            participant_id,
            bankReceipt,

        }
       
        setIsSubmitting(true);
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
              }

            axios.post(`/api/workshop-particepant-bank-verification-participant`, data, config).then(res => {

                if (res.data.status === 200) {
                        
                    swal('Success', res.data.message, 'success');
                    //history.push('/login');
                    history.push(`/workshop/thank-you/${participantId}`);
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });
        setAddBank({
            //particent_id: `${participantSingleData.id || ""}`,
            particent_bank: "",
            particent_ref_no: "",
            
        });
        setBankReceipt({
            bankReceipt:"",
        });

    }
    return (
        <div>
            <Navbar />
            <ThemeProvider theme={theme}>
                <Container component="main" maxWidth="xs">
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 1, backgroundColor: '#145348' }}>
                            <LockOutlinedIcon />
                        </Avatar>
                        <Typography component="h1" variant="h5">
                            Bank Form
                        </Typography>
                        {/* <Typography style={{ color: 'red' }}>
  
              {registerInput.error_list.eventid  ? '* '  + " " +" You probably came through a wrong link Please Register from the conference Website Thank you.." :""}  
              </Typography> */}

                        <Box component="form" onSubmit={bankDetailSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={2}>

                                <TextField
                                    label="Invoice No"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name='particent_id'
                                    value={`INV${participantData.id || ""}`}
                                    disabled={true} />
                                <TextField
                                    label="Bank Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={addBank.particent_bank}
                                    onChange={(e) => setAddBank({ ...addBank, particent_bank: e.target.value })}

                                />
                                <TextField
                                    label="Ref Number"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={addBank.particent_ref_no}
                                    onChange={(e) => setAddBank({ ...addBank, particent_ref_no: e.target.value })}

                                />
                               <label htmlFor="icon-button-file">
                    <TextField id="icon-button-file" type="file" onChange={(e) => setBankReceipt(e.target.files[0])} name="[licenseFile]" />
                    <IconButton color="primary" aria-label="upload picture" component="span"
                    > Bank Receipt
                      <PhotoCamera />
                    </IconButton>
                  </label>
                  {/* <FormHelperText>{abstractAdminArticle.error_list.abstractImage}</FormHelperText> */}
                            </Grid>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, backgroundColor: '#145348' }}
                                disabled={isSubmitting} // Disable button when submitting
                                >
                                    {isSubmitting ? 'Submitting...' : 'Save'}
                            </Button>

                        </Box>
                    </Box>

                </Container>
            </ThemeProvider>
        </div>
    );
}

export default BankPaymentVerification;
